import { createSlice } from '@reduxjs/toolkit'
import { idle, loading } from './status'

const initialState = {
  allCoupons: {
    items: [],
    status: idle,
  },
  allCouponsOptions: [],
  memberCoupons: {
    status: 'a',
    membership: [],
  },
  timeline: {
    items: [],
    status: idle,
  },
  redeems: {
    items: [],
    counts: [],
  },
  member: {},
}

export const membershipSlice = createSlice({
  name: 'membership',
  initialState,
  reducers: {
    syncAllCoupons: (state, action) => {
      state.allCoupons = {
        items: action.payload.items,
        status: action.payload.status,
      }
      state.allCouponsOptions = action.payload.items
        .filter((i) => i.status === 'Publish' && (i.level === 'B' || i.level === 'BP'))
        .map((item) => ({
          label: item.code,
          value: item.code,
        }))
    },
    syncMemberCoupons: (state, action) => {
      state.memberCoupons = {
        ...action.payload,
        membership: action.payload.membership.map((item) => {
          // const allCoupon = state.allCoupons.items.find((ac) => ac.code === item.code)
          return {
            code: item.code,
            yearly: item.yearly,
            level: item.level,
            type: item.type,
            // logic: allCoupon?.logic,
            // onceInMonth: allCoupon?.onceInMonth || false,
            // monthly: allCoupon?.monthly ?? Math.ceil(item.yearly / 12),
            redeemMonth: item?.redeemMonth ?? 0,
            yearlyUsed: item.yearlyUsed ?? 0,
            monthlyUsed: item.monthlyUsed ?? 0,
          }
        }),
      }
    },
    rewardCoupons: (state, action) => {
      state.memberCoupons.membership = action.payload.membership
    },
    syncRedeems: (state, action) => {
      state.redeems = {
        items: action.payload.items,
        counts: action.payload.counts,
      }
    },
    loadingTimeline: (state) => {
      state.timeline = {
        items: [],
        status: loading,
      }
    },
    syncTimeline: (state, action) => {
      state.timeline = {
        items: action.payload.items,
        status: action.payload.status,
      }
    },
    redeemCoupon: (state, action) => {
      state.memberCoupons.membership = state.memberCoupons.membership.map((mc) => {
        if (mc.code === action.payload.code && mc.yearlyUsed < mc.yearly) {
          return { ...mc, yearlyUsed: mc.yearlyUsed + 1, monthlyUsed: mc.monthlyUsed + 1 }
        }
        return { ...mc }
      })
    },
    setMember: (state, action) => {
      state.member = action.payload
    },
    unsetMember: (state, action) => {
      state.member = {}
    },
  },
})

export const membershipAction = membershipSlice.actions

export const selectMembership = (state) => state.membership

export default membershipSlice.reducer
